import React, {useContext} from "react";
import {useState, useEffect} from "react";
import {ReactComponent as DropDownIcon} from "../../../assets/images/dropdown_icon.svg";
import {AssignedHubContext} from "../../controllers/first_mile_controllers";
import {
    addToExistingTaskApiCall, areaListForFilterApiCall, cityListForFilterApiCall, conceptListForFilterApiCall,
    fmOrderCountApiCall,
    pickupTaskListApiCall, vendorListForFilterApiCall, binListForFilterApiCall
} from "../../controllers/pick_up_order_controller";
import {PickupTaskListModel} from "../../models/pickup_task_list_model";
import PickupOrdersPage from "./pickup_orders_page";
import ReturnOrderPage from "./return_order_page";
import RtoOrderPage from "./rto_order_page";
import {showErrorToast} from "../../../components/toast/error_toast";
import StringUtils from "../../../utils/string_utils";
import {showSuccessToast} from "../../../components/toast/success_toast";
import FirstMileOrderTabs from "./first_mile_order_tabs";
import WarehouseDropdown from "../task_allocation/warehouse_dropdown";
import CommonSearchFiled from "../../../components/commonSearchField";
import FilterComponent from "../../../components/filter_component";
import CommonTextWithRoundedShape from "../../../components/CommonTextWithRoundedShape";
import {FullButton} from "../../../components/button/common_button";
import stringUtils from "../../../utils/string_utils";
import CommonColorUtils from "../../../utils/common_colors";
import MyPagination from "../../../components/pagination/pagination";
import {CreateTaskDialog} from "./create_task/create_task_dialog";
import {AddToExistingDialog} from "./add_to_existing/add_to-existing_dialog";
import {AddToExistingNotAllowedDialog} from "./add_to_existing/add_to_existing_task_not_allowed_dialog";
import {AddToExistingConfirmDialog} from "./add_to_existing/add_to_existing_confirmation_dailog";
import {FmOrderCountModel} from "../../models/fm_order_count_model";
import FmFilterDataComponent from "./filter_component";
import {footerStyles} from "../../../components/style/common_style";


const FirstMileOrdersPage = () => {
    let firstRender = true;
    const [activeTab, setActiveTab] = useState(0);
    const [isBusy, setIsBusy] = useState(false);
    const [wareHouseList, setWarehouseList] = useState([]);
    const [selectedHubId, setSelectedHubId] = useState(
        parseInt(localStorage.getItem("clientLocationId"))
    );
    const [selectedHubName, setSelectedHubName] = useState(
        (localStorage.getItem("clientLocationName"))
    );
    const [taskType, setTaskType] = useState("forward");
    const [wareHouseMap, setWareHouseMap] = useState(new Map());// to get the change warehouse data name and other data in O(1) time
    const hub = useContext(AssignedHubContext);
    const [totalPages, setTotalPage] = useState(1);
    const [orderCount, setOrderCount] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [isStart, setIsStart] = useState(false);
    const [searchText, setSearchText] = useState([]);
    const [pickupTaskList, setPickupTaskList] = useState([]);
    const [selectedCpAwbs, setSelectedCpAwbs] = useState([]); // Track selected rows
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [isCreateTaskDialogOpen, setIsCreateTaskDialogOpen] = useState(false);
    const [isAddToExistingDialogOpen, setIsAddToExistingDialogOpen] = useState(false);
    const [isAddToExistingConfirmDialogOpen, setIsAddToExistingConfirmDialogOpen] = useState(false);
    const [isAddToExistingNotAllowedDialogOpen, setAddToExistingNotAllowedDialogOpen] = useState(false);
    const [selectedHub, setSelectedHub] = useState(null);
    const [addToExistingModel, setAddToExistingModel] = useState(null);
    const [selectedTask, setSelectedTask] = useState(null);
    const [selectedOrderCount, setSelectedOrderCount] = useState(0);
    const [commonCount, setCommonCount] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [vendorFilterList, setVendorFilterList] = useState([]);
    const [binFilterList, setBinFilterList] = useState([]);
    const [cityFilterList, setCityFilterList] = useState([]);
    const [areaFilterList, setAreaFilterList] = useState([]);
    const [conceptFilterList, setConceptFilterList] = useState([]);
    const [isFilterComponentApiCall, setIsFilterComponentApiCall] = useState(false);
    const [selectedFilterCount, setSelectedFilterCount] = useState(0);
    const [selectedFilterItems, setSelectedFilterItems] = useState(new Map());
    const [dateSelection, setDateSelection] = useState(StringUtils.dateRange);
    const [dateRange, setDateRange] = useState({start: null, end: null});
    const [specificDate, setSpecificDate] = useState(null);

    const handleOnChangeTabs = (events, updatedTab) => {
        setPage(0);
        setSearchText([]);
        setIsFilterOpen(false);
        setActiveTab(updatedTab);
        setSelectedFilterCount(0);
        setSelectedFilterItems(new Map());
        setDateRange({start: null, end: null});
        setDateSelection(StringUtils.dateRange);
        setSpecificDate(null);
        if (updatedTab === 0) {
            setTaskType("forward");
        } else if (updatedTab === 1) {
            setTaskType("return");
        } else if (updatedTab === 2) {
            setTaskType("rto");
        }
    };

    const handleUpdatedCount = (orderCount, totalPages) => {
        setOrderCount(orderCount);
        setTotalPage(totalPages);
        setCommonCount((prevState) => {
            if (activeTab === 0) {
                return {
                    ...prevState, // Ensure previous state is retained first
                    pickupCount: orderCount,
                };
            } else if (activeTab === 1) {
                return {
                    ...prevState,
                    returnCount: orderCount,
                };
            } else if (activeTab === 2) {
                return {
                    ...prevState,
                    rtoCount: orderCount,
                };
            }
        });

    }

    const fetchPickupTaskDetailsList = async () => {
        try {
            setIsBusy(true);
            const response = await pickupTaskListApiCall(taskType, searchText, selectedHubId, pageSize, page + 1, selectedFilterItems, dateSelection, dateRange, specificDate);
            if (response) {
                const pickupTaskListModel = PickupTaskListModel.fromJson(response);
                setPickupTaskList(pickupTaskListModel.results ?? []);
                handleUpdatedCount(pickupTaskListModel.count ?? 0, pickupTaskListModel.total ?? 0);
            }
        } catch (e) {
            setPickupTaskList([]);
            handleUpdatedCount(0, 0);
        } finally {
            setIsBusy(false);
        }
    };

    const orderCountApiCalling = async () => {
        try {
            // setIsBusy(true);
            const response = await fmOrderCountApiCall();
            if (response) {
                const fmOrderCountModel = FmOrderCountModel.fromJson(response);
                setCommonCount(fmOrderCountModel);
            }
        } catch (e) {
            console.error(e);
        } finally {
            // setIsBusy(false);
        }
    };
    const fetchVendorFilterListData = async () => {
        try {
            setIsFilterComponentApiCall(true);
            const response = await vendorListForFilterApiCall(taskType);
            setVendorFilterList(response);
        } catch (e) {
            console.error(e);
        } finally {
            setIsFilterComponentApiCall(false);
        }
    };
    const fetchBinFilterListData = async () => {
        try {
            setIsFilterComponentApiCall(true);
            const response = await binListForFilterApiCall();
            const assetMasterCodes = ['-'].concat(response.map((model) => model.asset_master_code));
            setBinFilterList(assetMasterCodes);
        } catch (e) {
            console.error(e);
        } finally {
            setIsFilterComponentApiCall(false);
        }
    };
    const fetchCityFilterListData = async () => {
        try {
            setIsFilterComponentApiCall(true);
            const response = await cityListForFilterApiCall(taskType);
            setCityFilterList(response);
        } catch (e) {
            console.error(e);
        } finally {
            setIsFilterComponentApiCall(false);
        }
    };
    const fetchAreFilterListData = async () => {
        try {
            setIsFilterComponentApiCall(true);
            const response = await areaListForFilterApiCall(taskType);
            setAreaFilterList(response);
        } catch (e) {
            console.error(e);
        } finally {
            setIsFilterComponentApiCall(false);
        }
    };
    const fetchConceptFilterListData = async () => {
        try {
            setIsFilterComponentApiCall(true);
            const response = await conceptListForFilterApiCall(taskType);
            setConceptFilterList(response);
        } catch (e) {
            console.error(e);
        } finally {
            setIsFilterComponentApiCall(false);
        }
    };


    useEffect(() => {
        if (firstRender) {
            orderCountApiCalling();
            fetchVendorFilterListData();
            fetchCityFilterListData();
            fetchAreFilterListData();
            fetchConceptFilterListData();
            fetchBinFilterListData();
        }

    }, [taskType, selectedHubId])


    useEffect(() => {
        if (firstRender) {
            if (!(searchText.length <= 250)) {
                return; // Exit early if searchText length exceeds 250
            }
            setSelectedCpAwbs([]);
            setIsAllChecked(false);
            setSelectedOrderCount(0);
            fetchPickupTaskDetailsList();
        }
        firstRender = false;


    }, [taskType, searchText, selectedHubId, pageSize, page + 1, selectedFilterItems, dateSelection, dateRange, specificDate]);


    const handleOnChangeWarehouse = (event) => {
        let changedHub = event.target.value;
        setSearchText([]);
        setIsFilterOpen(false);
        setSelectedHubId(changedHub);
        setSelectedFilterCount(0);
        setSelectedFilterItems(new Map());
        setDateRange({start: null, end: null});
        setDateSelection(StringUtils.dateRange);
        setSpecificDate(null);
        localStorage.setItem("clientLocationId", changedHub);
        const item = wareHouseMap.get(Number(changedHub));
        setSelectedHub(item);
        const itemName = item ? item.location_name : null;
        setSelectedHubName(itemName);
        localStorage.setItem("clientLocationName", itemName);
    };

    const setWarehouseListing = () => {
        const newWareHouseMap = new Map();
        hub.forEach((element) => {
            if (selectedHubId === element.location_id) {
                setSelectedHub(element);
            }
            newWareHouseMap.set(element.location_id, element);
        });

        setWareHouseMap(newWareHouseMap);
        setWarehouseList(hub);

    }


    useEffect(() => {
        setWarehouseListing();
    }, []);

    const selectedTabContent = () => {
        switch (activeTab) {
            case 0:
                return <PickupOrdersPage fmOrderList={pickupTaskList} selectedCpAwbs={selectedCpAwbs}
                                         setSelectedCpAwbs={setSelectedCpAwbs} isBusy={isBusy}
                                         isAllChecked={isAllChecked}
                                         setIsAllChecked={setIsAllChecked}/>;
            case 1:
                return <ReturnOrderPage fmOrderList={pickupTaskList} selectedCpAwbs={selectedCpAwbs}
                                        setSelectedCpAwbs={setSelectedCpAwbs} isBusy={isBusy}
                                        isAllChecked={isAllChecked}
                                        setIsAllChecked={setIsAllChecked}/>;

            case 2:
                return <RtoOrderPage fmOrderList={pickupTaskList} selectedCpAwbs={selectedCpAwbs}
                                     setSelectedCpAwbs={setSelectedCpAwbs} isBusy={isBusy} isAllChecked={isAllChecked}
                                     setIsAllChecked={setIsAllChecked}/>;
        }
    }

    const handleAddToExistingDialog = () => {
        if (selectedCpAwbs.length === 0) {
            showErrorToast(StringUtils.pleaseSelectMinimumOneOrder);
            return;
        }

        const selectedTaskList = pickupTaskList
            .filter((order) => selectedCpAwbs.includes(order.awb)) // Check if cpAwb is in the selected list
        ;

        const vendorLocations = selectedTaskList // Check if cpAwb is in the selected list
            .map((order) => order.vendorLocation);


        const areAllSame = vendorLocations.every((location) => location === vendorLocations[0]);

        if (areAllSame) {
            let selectedTotalOrderCount = 0;
            selectedTaskList.forEach((order) => {
                selectedTotalOrderCount += order.boxCount ?? 1;
            });


            setSelectedOrderCount(selectedTotalOrderCount);

            setIsCreateTaskDialogOpen(false);
            setAddToExistingNotAllowedDialogOpen(false);
            setIsAddToExistingDialogOpen(true);
        } else {
            setAddToExistingNotAllowedDialogOpen(true);
        }


    }

    const handleCreateTaskDialog = () => {
        if (selectedCpAwbs.length === 0) {
            showErrorToast(StringUtils.pleaseSelectMinimumOneOrder);
            return;
        }
        setIsCreateTaskDialogOpen(true);
    }


    const handleCloseForCreateDialog = (event, reason, callListingApi = false) => {
        ///to prevent dispose the popup on click of outside
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        setIsCreateTaskDialogOpen(false);

        if (callListingApi) {
            setSelectedCpAwbs([]);
            setIsAllChecked(false);
            fetchPickupTaskDetailsList();
        }
    };
    const handleCloseForAddToExistingDialog = (event, reason) => {
        ///to prevent dispose the popup on click of outside
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }

        setIsAddToExistingDialogOpen(false);

    };

    const handleCloseForAddToExistingNotAllowedDialog = (event, reason) => {
        ///to prevent dispose the popup on click of outside
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }

        setAddToExistingNotAllowedDialogOpen(false);

    };
    const handleCloseForAddToExistingConfirmDialog = (event, reason) => {
        ///to prevent dispose the popup on click of outside
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }

        setIsAddToExistingConfirmDialogOpen(false);

    };

    const handleAddToExistingButton = (addToExistingModel, selectedTask) => {
        setAddToExistingModel(addToExistingModel);
        setSelectedTask(selectedTask);
        setIsAddToExistingDialogOpen(false);
        setIsAddToExistingConfirmDialogOpen(true);
    }

    const addToExistingTaskApi = async () => {
        try {
            setIsBusy(true);
            const response = await addToExistingTaskApiCall(addToExistingModel, selectedTask.id);
            if (response) {
                showSuccessToast(response.message);
                setSelectedCpAwbs([]);
                setIsAllChecked(false);
                setSelectedOrderCount(0);
                await fetchPickupTaskDetailsList();
            }
        } catch (e) {
            const errorMessage = e.message.replaceAll("Error:", "");
            showErrorToast(errorMessage);
        } finally {
            setIsBusy(false);
        }
    };

    const handleAddToExistingConfirmButton = async () => {
        setIsAddToExistingConfirmDialogOpen(false);
        await addToExistingTaskApi();
    }


    const handleSubmit = (selectedFilterItem, {
        dateSelection = StringUtils.dateRange,
        dateRange = {start: null, end: null},
        specificDate = null
    } = {}) => {
        setSelectedFilterItems(selectedFilterItem);
        setDateSelection(dateSelection);
        setDateRange(dateRange);
        setSpecificDate(specificDate);
    }

    const handleClearAll = ({
                                selectedFilterItem = new Map(),
                                dateSelection = StringUtils.dateRange,
                                dateRange = {start: null, end: null},
                                specificDate = null
                            } = {}) => {
        setSelectedFilterItems(selectedFilterItem);
        setDateSelection(dateSelection);
        setDateRange(dateRange);
        setSpecificDate(specificDate);
    }


    return (
        <>
            <div style={{display: "flex"}}>
                <FirstMileOrderTabs
                    activeTabValue={activeTab}
                    handleOnChangeTabs={handleOnChangeTabs}
                    commonCount={commonCount}
                />

                <WarehouseDropdown
                    options={wareHouseList}
                    selectedValue={selectedHubId}
                    onChange={handleOnChangeWarehouse}
                />
            </div>
            <div style={{display: "flex", justifyContent: "space-between", marginTop: "-5px"}}>
                <div
                    style={{display: "flex"}}>
                    <CommonSearchFiled
                        label={StringUtils.searchAwb}
                        initialSearchText={searchText?.join(",")}
                        onSearch={(text) => {
                            setPage(0);

                            const searchEntryList = text
                                .trim()
                                .replace(/^,|,$/g, '')
                                .split(/[,\s]+/);

                            if (searchEntryList.length <= 250) {
                                setSearchText(searchEntryList);
                            } else {
                                showErrorToast(StringUtils.maximum250OrdersCanBeSearchedAtATime);
                                setOrderCount(orderCount);
                                setTotalPage(totalPages);
                            }


                        }}
                        onClear={() => {
                            setPage(0);
                            setSearchText([]);
                        }}
                        width="400px"
                        borderRadius="8px"
                        sx={{
                            marginLeft: "15px", marginTop: "15px",
                            display: "flex", // Enable flexbox
                            "& .MuiOutlinedInput-input": {
                                height: "15px",
                            },
                            "& .MuiInputLabel-root": {
                                top: "50%", // Align placeholder vertically
                                transform: "translateY(-50%)", // Proper vertical centering
                                left: "3%", // Center horizontally
                            },
                            "& .MuiInputLabel-shrink": {
                                top: "0", // Move placeholder to top when focused
                                transform: "translateY(-40%) scale(0.75)", // Shrink and align correctly
                            },
                        }}
                    />

                    <FilterComponent count={selectedFilterCount} Icon={DropDownIcon}
                                     onClick={isFilterComponentApiCall ? null : (event) => {
                                         setIsFilterOpen((prevState) => !prevState);
                                         setAnchorEl(event.currentTarget);
                                     }}/>
                </div>
                <FmFilterDataComponent
                    open={isFilterOpen}
                    anchorEl={anchorEl}
                    setIsFilterOpen={setIsFilterOpen}
                    setSelectedFilterCount={setSelectedFilterCount}
                    options={{
                        "Vendor Location": vendorFilterList,
                        City: cityFilterList,
                        Area: areaFilterList,
                        Concept: conceptFilterList,
                        "Asset ID": binFilterList,
                    }}
                    labels={["Vendor Location", "City", "Area", "Concept", "Created on","Asset ID"]}
                    handleClearAll={handleClearAll}
                    handleSubmit={handleSubmit}
                    initialSelectedFilters={selectedFilterItems}
                    selectedDateLabel={dateSelection}
                    selectedDateRange={dateRange}
                    selectedSpecificDate={specificDate}
                />

                {selectedCpAwbs.length !== 0 && <div
                    style={{display: "flex", marginTop: "15px", height: "48px"}}>
                    <CommonTextWithRoundedShape text={`selected(${selectedCpAwbs.length})`} horizontalPadding={5}
                                                verticalPadding={5} fontSize="14px"
                                                backgroundColor={CommonColorUtils.primaryGrey300}
                                                color={CommonColorUtils.primaryGrey600}/>

                </div>}

                <div
                    style={{display: "flex", gap: "10px", marginRight: "15px", marginTop: "15px"}}>
                    <FullButton
                        buttonText={stringUtils.addToExisting}
                        activeColor={
                            CommonColorUtils.primaryKWhite
                        }
                        inactiveColor={
                            CommonColorUtils.primaryKWhite
                        }
                        buttonTextColor={
                            CommonColorUtils.primaryMainBlue
                        }

                        active={
                            true
                        }
                        height={"48px"}
                        width={"200px"}
                        borderColor={`1px solid ${CommonColorUtils.primaryMainBlue}`}
                        handleOnPress={handleAddToExistingDialog}
                    />
                    <FullButton
                        buttonText={stringUtils.createTask}
                        activeColor={
                            CommonColorUtils.primaryMainBlue
                        }
                        inactiveColor={
                            CommonColorUtils.primaryMainBlueDisabledColor
                        }
                        buttonTextColor={
                            CommonColorUtils.primaryKWhite
                        }
                        active={
                            selectedCpAwbs.length !== 0
                        }

                        height={"48px"}
                        width={"150px"}
                        handleOnPress={
                            handleCreateTaskDialog
                        }
                    />

                </div>
            </div>
            {selectedTabContent()}
            {orderCount !== 0 && (
                <div  style={{marginLeft: "15px",...footerStyles}}>
                    <MyPagination
                        currentPage={page + 1}
                        totalPages={totalPages}
                        onPageChange={setPage}
                        rowsPerPage={pageSize}
                        onRowsPerPageChange={setPageSize}
                        totalEntries={orderCount}
                        setIsStart={setIsStart}
                        marginRight={localStorage.getItem('isFromHostApplication') ? "11rem" : "5px"}
                    />
                </div>
            )}
            {isCreateTaskDialogOpen && <CreateTaskDialog
                isDialogOpen={isCreateTaskDialogOpen}
                handleCloseDialog={handleCloseForCreateDialog}
                selectedCpAwbs={selectedCpAwbs}
                taskType={taskType}
                hubId={selectedHubId}
                hubName={selectedHubName}
                selectedHub={selectedHub}
            />}
            {isAddToExistingDialogOpen && <AddToExistingDialog
                isDialogOpen={isAddToExistingDialogOpen}
                handleCloseDialog={handleCloseForAddToExistingDialog}
                selectedCpAwbs={selectedCpAwbs}
                taskType={taskType}
                hubId={selectedHubId}
                hubName={selectedHubName}
                selectedHub={selectedHub}
                handleAddToExistingButton={handleAddToExistingButton}
                selectedOrderCount={selectedOrderCount}
            />}
            {isAddToExistingNotAllowedDialogOpen && <AddToExistingNotAllowedDialog
                isDialogOpen={isAddToExistingNotAllowedDialogOpen}
                handleCloseDialog={handleCloseForAddToExistingNotAllowedDialog}
            />}
            {isAddToExistingConfirmDialogOpen && <AddToExistingConfirmDialog
                isDialogOpen={isAddToExistingConfirmDialogOpen}
                handleCloseDialog={handleCloseForAddToExistingConfirmDialog}
                selectedOrderCount={selectedCpAwbs}
                taskType={taskType}
                selectedTask={selectedTask?.taskName}
                handleAddToExistingConfirmButton={handleAddToExistingConfirmButton}
            />}
        </>
    );
};
export default FirstMileOrdersPage;
